import React from 'react';
import { Card, Badge } from 'flowbite-react';
import { HiClock, HiCheckCircle, HiXCircle, HiServer } from 'react-icons/hi';
import type { WorkflowExecutionSummary } from '../../api/workflowInspector';
import { formatDuration, getStatusColor } from '../../api/workflowInspector';

interface ExecutionSummaryProps {
  execution: WorkflowExecutionSummary;
}

const ExecutionSummary: React.FC<ExecutionSummaryProps> = ({ execution }) => {
  return (
    <Card>
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">{execution.Workflow_Name}</h3>
          <p className="text-sm text-gray-500">
            {execution.Triggered_By} &mdash; {new Date(execution.Started_At).toLocaleString()}
          </p>
        </div>
        <Badge color={getStatusColor(execution.Status)} size="sm">
          {execution.Status}
        </Badge>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="flex items-center gap-2">
          <HiClock className="w-5 h-5 text-blue-500" />
          <div>
            <p className="text-xs text-gray-500">Duration</p>
            <p className="text-sm font-medium">{formatDuration(execution.Duration_Ms)}</p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <HiCheckCircle className="w-5 h-5 text-green-500" />
          <div>
            <p className="text-xs text-gray-500">Steps</p>
            <p className="text-sm font-medium">{execution.Completed_Steps}/{execution.Total_Steps}</p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <HiXCircle className="w-5 h-5 text-red-500" />
          <div>
            <p className="text-xs text-gray-500">Failed</p>
            <p className="text-sm font-medium">{execution.Failed_Steps}</p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <HiServer className="w-5 h-5 text-gray-500" />
          <div>
            <p className="text-xs text-gray-500">Environment</p>
            <p className="text-sm font-medium">{execution.Environment || '-'}</p>
          </div>
        </div>
      </div>

      {execution.Error_Message && (
        <div className="mt-3 bg-red-50 border border-red-200 rounded px-3 py-2">
          <p className="text-sm text-red-700">{execution.Error_Message}</p>
        </div>
      )}
    </Card>
  );
};

export default ExecutionSummary;
